let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("5ppK3"), load("ffEVr"), load("ht9O7")]).then(() => parcelRequire('eTYeK'));